<template>
 <v-layout>
    <panel :title="$t('dataPage.deleteData')">
      <v-form v-model="formValid" ref="form">
        <v-select
          v-if="boluses"
          v-model="selectedBolus"
          :items="boluses"
          item-text="bolusName"
          item-value="bolusID"
          return-object
          :rules="[v => !!v || 'Item is required']"
          :label="$t('bolusGenerics.bolusName')"
        ></v-select>
        <date-time-picker-with-zone
          class="date-picker"
          @dateChanged="newDate => (fromDate = newDate)" 
          :actDate="fromDate"
          :label="$t('graph.from')"
          :labelSeparateLine="true"
        />
        <date-time-picker-with-zone
          class="date-picker"
          @dateChanged="newDate => (toDate = newDate)" 
          :actDate="toDate"
          :label="$t('graph.to')"
          :labelSeparateLine="true"
        />
        <div class="form-error" v-if="error">
          <p>{{error}}</p>
        </div>
        <v-btn
          color="secondary"
          @click="validateAndOpenConfirm"
          >
          {{$t('actions.send')}}
        </v-btn>
      </v-form>
    </panel>
    <v-dialog max-width="500px" v-model="confirmDialog">
      <panel :title="$t('actions.areYouSure')">
        <v-flex v-if="confirmDialog">
          {{$t('bolusGenerics.bolusName') + ': ' + selectedBolus.bolusName}}
          {{$t('graph.from') + ' ' + $moment(fromDate).format('LLL')}}
          {{$t('graph.to') + ' ' + $moment(toDate).format('LLL')}}
        </v-flex>
      <v-form>
        <v-checkbox 
          v-model="confirm" 
          :label="$t('actions.confirm')"
        ></v-checkbox>
        <v-btn
          :disabled="!confirm"
          block
          class="secondary button-modal"
          @click="sendDeleteRequest()"
          >
          {{$t('actions.send')}}
        </v-btn>        
      </v-form>
      </panel>
    </v-dialog>
  </v-layout>
</template>

<script>
import BolusApi from "@/api/bolus-api";
import SensorLogService from '@/services/SensorLogService'
import UtilsService from '@/services/UtilsService'

export default {
  data () {
    return {
      boluses: [],
      fromDate: null,
      toDate: null,
      error: null,
      selectedBolus: null,
      confirmDialog: false,
      confirm: false,
      confirmValid: false,
      formValid: false
    }
  },
  async mounted () {
    this.boluses = (await BolusApi.list()).data
  },
  methods: {
    validateAndOpenConfirm () {
      this.error = null
      if (!this.fromDate || !this.toDate || !this.selectedBolus) {
        this.error = this.$t('mainErrors.fieldsRequired')
        return;
      }
      
      this.confirmDialog = true
    },
    sendDeleteRequest () {
      try {
        SensorLogService.deleteData(
          UtilsService.formatRequestDate(this.fromDate),
          UtilsService.formatRequestDate(this.toDate),
          this.selectedBolus.bolusID,)
        this.confirmDialog = false
        this.$emit('close')
      } catch (error) {
        this.confirmDialog = false
        this.error = this.$t('mainErrors.somethingWrong')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.date-picker {
  padding: 15px;
}

.form-error > p {
  background: rgb(250, 102, 102);
  width: 100%;
  border-radius: 6px;
  padding: 5px;
  font-weight: 500;
}

</style>



// WEBPACK FOOTER //
// src/components/DeleteData.vue